import React from "react";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import {Backend, Imprint, MapData} from "../../common/Legal/Legal";
import PropTypes from 'prop-types';

import {InfoDialogContent} from "./InfoDialog.sc";

const InfoDialog = (props) => {

    const {open, onClose} = props;

    return (
        <Dialog onClose={onClose} open={open}>
            <DialogTitle>About map2stl.com</DialogTitle>
            <InfoDialogContent>
                <div>
                    <Backend/>
                </div>
                <div>&middot;</div>
                <div>
                    <MapData/>
                </div>
                <div>&middot;</div>
                <div>
                    <Imprint/>
                </div>
            </InfoDialogContent>
        </Dialog>
    )
};

InfoDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};

export default InfoDialog;



// WEBPACK FOOTER //
// ./src/mobile/InfoDialog/InfoDialog.js